import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { initAnalytics } from "./app/lib/analytics";
import "./app.css";

// Initialise analytics (PostHog) — no-op if VITE_PUBLIC_POSTHOG_KEY is not set
initAnalytics();

createRoot(document.getElementById("root")!).render(<App />);
